import { useFetchAllPreferredCarrierWithGroups } from '@uturn/api/v2';
import { Permission } from '@uturn/portal/abac';
import {
	FormControl,
	FormItem,
	FormMessage,
	Input,
	MultiSelect,
} from '@uturn/ui-kit';
import { useAbac } from 'react-abac';
import { useTranslation } from 'react-i18next';

type RHFFieldLike = {
	value: unknown;
	onChange: (v: unknown) => void;
	name?: string;
};

export const CarriersMultiSelect = ({ field }: { field: RHFFieldLike }) => {
	const { userHasPermissions } = useAbac();
	const { t } = useTranslation();

	const canInvite = userHasPermissions(Permission.INVITE_CARRIER);

	const { data: carriers } = useFetchAllPreferredCarrierWithGroups({
		query: {
			enabled: canInvite,
			select: (data) => [
				...(data.data.carrierGroup?.map((group) => ({
					value: group.groupId,
					name: group.groupName,
					options: group.carriers.map((carrier) => ({
						value: carrier.organizationId,
						label: carrier.organizationName,
					})),
				})) ?? []),
				...(data.data.individualCarriers?.map((carrier) => ({
					value: carrier.organizationId,
					label: carrier.organizationName,
				})) ?? []),
			],
		},
	});

	if (!carriers || carriers.length === 0) {
		const message = canInvite
			? t('general.no_data', 'No carriers available')
			: t('pages.carriers.actions-denied.add.title', 'Waiting for approval');

		return <Input disabled placeholder={message} />;
	}

	return (
		<FormItem>
			<FormControl>
				<MultiSelect
					onChange={field.onChange}
					placeholder={t(
						'pages.multi-update.preferred_carries.placeholder',
						'Select carrier',
					).toString()}
					selected={field.value as number[]} // List of organizationId
					options={carriers}
					selectAllEnabled
					modal={true}
					align="start"
					maxDisplay={3}
					maxItemLength={7}
					searchPlaceholder={t(
						'pages.multi-update.preferred_carries.search.placeholder',
						'Search carrier...',
					).toString()}
					emptyMessage={t(
						'pages.multi-update.preferred_carries.search.empty',
						'No carriers found.',
					).toString()}
				/>
			</FormControl>
			<FormMessage />
		</FormItem>
	);
};
